import {
    AnalyticsAttributesProvider,
    Column,
    isColumnProperties
} from "../../components";
import { UiColumnModel } from "../../models";
import { renderViewModels } from "../../render-view-model";
import { BackgroundFieldValue } from "../../styles";
import { MapModelToProps } from "../../utils";

export type UiColumnProps = MapModelToProps<UiColumnModel>;

const UiColumn = ({ model }: UiColumnProps) => {
    const {
        title,
        blocks = [],
        elementId,
        properties = {},
        background
    } = model.content;

    if (isColumnProperties(properties)) {
        return (
            <Column
                id={elementId}
                className="ui-column"
                backgroundField={background as BackgroundFieldValue}
                {...properties}
            >
                <AnalyticsAttributesProvider
                    value={{
                        eventContainer: "uiColumn",
                        labelEnglish: title
                    }}
                >
                    {renderViewModels(blocks)}
                </AnalyticsAttributesProvider>
            </Column>
        );
    } else {
        throw new Error(
            "TODO: handle case where properties does not pass schema check."
        );
    }
};

export default UiColumn;
